import { useWSMutation } from "@ws-react-query";
import { updateInsuranceImport } from "../../../services/api/insurance/import/updateInsuranceImport";
import { InsuranceImportUpdateRequest } from "../../../services/api/insurance/import/types";
import { QUERY_INSURANCE_IMPORT } from "../keys";

export const useMutationUpdateInsuranceImport = () => {
  return useWSMutation(
    ({
      insuranceImportId,
      request
    }: {
      insuranceImportId: string;
      request: InsuranceImportUpdateRequest;
    }) => {
      return updateInsuranceImport(insuranceImportId, request);
    },
    {
      dependencies: [QUERY_INSURANCE_IMPORT]
    }
  );
};
